import { HighchartsReact } from 'highcharts-react-official';
import Highstock, { Options, SeriesLineOptions } from 'highcharts/highstock';
import { useSgBsTheme } from 'hooks/useSgBsTheme';
import { FC, useMemo } from 'react';
import styled from 'styled-components';
import { toHighchartsTheme } from 'utils/highcharts';

interface TimeSeriesChartProps {
  seriesLineOptions: SeriesLineOptions[];
}

export const StyledHighchartsContainer = styled.div`
  .highcharts-series-inactive {
    opacity: 1 !important;
  }
`;

export const TimeSeriesChart: FC<TimeSeriesChartProps> = ({ seriesLineOptions }) => {
  const theme = useSgBsTheme();
  const options = useHighChartTimeSeriesOptions(seriesLineOptions);

  return (
    <StyledHighchartsContainer>
      <HighchartsReact
        highcharts={Highstock}
        options={options}
        containerProps={{ className: toHighchartsTheme(theme) }}
      />
    </StyledHighchartsContainer>
  );
};

function useHighChartTimeSeriesOptions(seriesLineOptions: SeriesLineOptions[]): Options {
  return useMemo(
    () => ({
      chart: { styledMode: true, height: 600, backgroundColor: 'transparent' },
      credits: { enabled: false },
      title: { text: undefined },
      xAxis: { labels: {}, type: 'datetime' },
      yAxis: { title: { text: '' } },
      legend: { layout: 'horizontal', align: 'left', verticalAlign: 'top' },
      plotOptions: { series: { label: { connectorAllowed: false } } },
      series: seriesLineOptions,
      exporting: {
        enabled: true,
        accessibility: { enabled: true },
        allowHTML: false,
        allowTableSorting: true,
        buttons: {
          contextButton: {
            enabled: true,
            menuItems: ['viewFullscreen', 'printChart', 'separator', 'downloadPNG', 'downloadJPEG', 'downloadSVG'],
          },
        },
      },
    }),
    [seriesLineOptions],
  );
}
